import {FC} from 'react'

import {CardListLayout} from '@/components/common/cards/CardListLayout'
import {CardWrapper} from '@/components/common/cards/CardWrapper'
import {ContentCard} from '@/components/common/content/ContentCard'
import {brandMonitoringPlatformImages} from '@/content/brand-monitoring/constants'
import {
  BrandSubscriptionPlatform,
  NotOfferedBrandSubscriptionPlatform,
} from '@/utils/brand-subscription/constants'
import {BrandProtectionGuideBasicInfo} from '@/utils/contentful'
import {routeTo} from '@/utils/router'

type BrandProtectionGuideCardListProps = {
  title: string
  description?: string
  cards: BrandProtectionGuideBasicInfo[]
  numOfCardsPerRow?: number
  showDescription?: boolean
}

export const BrandProtectionGuideCardList: FC<BrandProtectionGuideCardListProps> = ({
  title,
  description,
  cards,
  numOfCardsPerRow,
  showDescription = true,
}) => (
  <CardListLayout title={title} description={description}>
    {cards.map(({platformKey, platformTitle, platformSlug, homeCardDescription}) => {
      // Not every guide covers a platform we monitor.
      const content = brandMonitoringPlatformImages[
        platformKey as BrandSubscriptionPlatform | NotOfferedBrandSubscriptionPlatform
      ] ?? {
        imageSrc: '/images/icons/binoculars.svg',
        imageAlt: 'Binoculars',
      }

      return (
        <CardWrapper key={platformKey} numOfCardsPerRow={numOfCardsPerRow}>
          <ContentCard
            title={platformTitle}
            imageSrc={content.imageSrc}
            imageAlt={content.imageAlt}
            description={showDescription ? homeCardDescription : undefined}
            linkHref={routeTo.brandProtectionGuide(platformSlug)}
            // A prefetch would be the whole static guide, once per card in view.
            prefetch={false}
            trackedEvent={{
              name: 'Brand protection guide card is clicked',
              parameters: {platformKey},
            }}
          />
        </CardWrapper>
      )
    })}
  </CardListLayout>
)
